import nodeService from "@/services/nodejs"

async function withdrawStoreCommit(state, payload){
    await state.commit(payload.mutation, payload.value)
}

const fetchPaymentsForAttractions = async (state, payload) => {
    state.commit("SET_IS_LOADING", true)

    await nodeService.getPaymentsForAttractions(payload)
        .then((response) => { state.commit('SET_ATTRACTIONS_PAYMENTS_LIST', response.data) })
        .catch((error) => { console.error("Error fetching payments:", error) })
        .finally(() => { state.commit("SET_IS_LOADING", false); })
}

const fetchWithdrawBookings = async (state, payload) => {
    state.commit("SET_IS_LOADING", true)

    await nodeService.getWithdrawBookings(payload.uuid)
        .then((response) => { state.commit('SET_WITHDRAW_BOOKINGS_LIST', response.data) })
        .catch((error) => { console.error("Error fetching withdraw bookings:", error) })
        .finally(() => { state.commit("SET_IS_LOADING", false); })
}

const fetchWithdrawPaymentsForAttractions = async (state, payload) => {
    state.commit("SET_IS_LOADING", true)

    await nodeService.withdrawReport(payload)
        .then((response) => {
            state.commit('SET_CURRENT_WITHDRAW_PAYMENTS', response.data) 
        })
        .catch((error) => { console.error("Error fetching payments in period:", error) })
        .finally(() => { state.commit("SET_IS_LOADING", false); })
}

const saveWithdrawForAttraction = async (state, payload) => {
    state.commit("SET_IS_LOADING", true)

    const payment = {
        start_date: payload.info.period.start,
        end_date: payload.info.period.end,
        places: [{
            uuid: payload.placeUuid,
            checked_in_only: payload.processed,
            obs: payload.obs,
        }]
    }

    await nodeService.postPaymentsForAttractions(payment)
        .then((response) => {})
        .catch((error) => { console.error("Error fetching payments in period:", error) })
        .finally(() => { state.commit("SET_IS_LOADING", false); })
}

export default {
    withdrawStoreCommit,
    fetchWithdrawPaymentsForAttractions,
    fetchWithdrawBookings,
    fetchPaymentsForAttractions,
    saveWithdrawForAttraction,
}